"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { RevokeFeedbackCollectionRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { revokeFeedbackLink } from "../api/revokeFeedbackLink";
import { feedbackKeys } from "../queries/keys";

export default function useRevokeFeedbackLinkMutation() {
  const { accessToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: RevokeFeedbackCollectionRequest) =>
      revokeFeedbackLink(accessToken, request),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: feedbackKeys.links() });
    },
  });
}
